function findByText(text, exact = false) {
	const els = document.querySelectorAll('span, p, label, h6, h5, h4, button, .MuiTypography-root')
	for (const el of els) {
		const content = el.textContent.trim().toLowerCase()
		if (exact ? content === text.toLowerCase() : content.includes(text.toLowerCase())) {
			return el
		}
	}
	return null
}

const ES = navigator.language?.startsWith('es')

export const TOUR_STEPS = [
	{
		type: 'intro',
		icon: 'gear',
		title: ES ? 'Bienvenido a Ajustes de usuario' : 'Welcome to User Settings',
		description: ES
			? 'Configura tus preferencias personales en cinco secciones: Tiers (grupos de proveedores), Grupos de oficinas, Grupos de sitios, Colores de sitios web y Colores de elementos (ACRISS y Categorías). Todos los ajustes se guardan en tu perfil y se aplican en toda la plataforma.'
			: 'Configure your personal preferences across five sections: Tiers (provider groups), Office Groups, Site Groups, Website Colors, and Item Colors (ACRISS & Categories). All settings are saved to your profile and used across the platform.',
	},
	{
		type: 'field',
		findTarget: () => {
			const tabs = document.querySelector('.MuiTabs-root')
			return tabs
		},
		icon: 'table-columns',
		title: ES ? 'Pestañas de ajustes' : 'Settings Tabs',
		description: ES
			? 'Navega entre las cinco secciones de configuración. TIERS: agrupa proveedores en niveles personalizados. GRUPO DE OFICINAS: agrupa oficinas para filtrado masivo. GRUPO DE SITIOS: agrupa sitios web. COLORES DE SITIOS WEB: asigna colores personalizados a sitios y proveedores para los gráficos. COLORES DE ELEMENTOS: asigna colores a códigos ACRISS y categorías de vehículos.'
			: 'Navigate between the five configuration sections. TIERS: group providers into custom tiers. OFFICE GROUP: group offices for bulk filtering. SITE GROUP: group websites. WEBSITE COLORS: assign custom colors to sites and providers for charts. ITEM COLORS: assign colors to ACRISS codes and vehicle categories.',
		example: ES
			? 'TIERS | GRUPO DE OFICINAS | GRUPO DE SITIOS | COLORES DE SITIOS WEB | COLORES DE ELEMENTOS'
			: 'TIERS | OFFICE GROUP | SITE GROUP | WEBSITE COLORS | ITEM COLORS',
	},
	{
		type: 'field',
		findTarget: () => {
			const icon = document.querySelector('.fa-add') || document.querySelector('[data-icon="add"]')
				|| document.querySelector('.fa-plus') || document.querySelector('[data-icon="plus"]')
			if (icon) {
				const btn = icon.closest('button')
				if (btn) return btn
			}
			const el = findByText('Define Tier') || findByText('Define')
			if (el) {
				const btn = el.closest('button') || el
				return btn
			}
			return null
		},
		icon: 'circle-plus',
		title: ES ? 'Crear nuevo elemento' : 'Create New Item',
		description: ES
			? 'Haz clic en este botón para crear una nueva entrada. Se abre un panel lateral con un formulario donde rellenas los datos (nombre, elementos asociados, color, etc.) y guardas. Cada pestaña tiene su propio botón de creación para el tipo de ajuste correspondiente.'
			: 'Click this button to create a new entry. A side drawer opens with a form where you fill in the details (name, associated items, color, etc.) and save. Each tab has its own create button for the corresponding setting type.',
	},
	{
		type: 'field',
		findTarget: () => {
			const papers = document.querySelectorAll('.MuiPaper-root, .MuiCard-root')
			for (const paper of papers) {
				if (!paper.textContent.includes('Your Tiers') && !paper.textContent.includes('Site Colors')
					&& !paper.textContent.includes('Provider Colors') && !paper.textContent.includes('Your Offices')
					&& !paper.textContent.includes('Your Sites')) continue
				const rows = paper.querySelectorAll('table tbody tr')
				const hasData = Array.from(rows).some(r =>
					r.querySelectorAll('td').length >= 2 && !r.textContent.includes('no matching records')
				)
				if (hasData) return paper
			}
			const el = findByText('Your Tiers') || findByText('Site Colors') || findByText('Your Offices')
			if (el) {
				const paper = el.closest('.MuiPaper-root')
				if (paper) return paper
			}
			return null
		},
		icon: 'table-cells',
		title: ES ? 'Tabla de ajustes' : 'Settings Table',
		description: ES
			? 'Tus configuraciones guardadas se muestran en una tabla. Los Tiers muestran nombre y proveedores asociados. Los Grupos de oficinas/sitios muestran nombre y elementos agrupados. Las pestañas de colores muestran nombre y un cuadrado de color con el código hexadecimal. Usa el buscador integrado para encontrar entradas específicas.'
			: 'Your saved configurations are displayed in a table. Tiers show name and associated providers. Office/Site Groups show name and grouped items. Color tabs show name and a colored square with the hex code. Use the built-in search to find specific entries.',
	},
	{
		type: 'field',
		findTarget: () => {
			const icon = document.querySelector('.fa-pen') || document.querySelector('[data-icon="pen"]')
			if (icon) {
				const btn = icon.closest('button')
				if (btn?.parentElement) {
					const row = btn.parentElement
					if (row.children.length >= 2) return row
				}
				return btn
			}
			return null
		},
		skipIf: () => !document.querySelector('.fa-pen') && !document.querySelector('[data-icon="pen"]'),
		icon: 'pen-to-square',
		title: ES ? 'Acciones de editar y eliminar' : 'Edit & Delete Actions',
		description: ES
			? 'Cada fila tiene botones de acción. Editar (icono de lápiz): abre el panel lateral con los valores actuales precargados para que puedas actualizarlos. Eliminar (icono de papelera): borra la entrada tras confirmación. Los cambios se guardan inmediatamente.'
			: 'Each row has action buttons. Edit (pencil icon): opens the side drawer with the current values pre-filled so you can update them. Delete (trash icon): removes the entry after confirmation. Changes are saved immediately.',
		example: ES
			? '✏️ Editar | 🗑️ Eliminar'
			: '✏️ Edit | 🗑️ Delete',
	},
	{
		type: 'outro',
		icon: 'star',
		title: ES ? '¡Todo listo!' : "You're All Set!",
		description: ES
			? 'Cambia entre pestañas para gestionar los distintos ajustes. Crea tiers para agrupar proveedores y filtrar, organiza oficinas y sitios en grupos, y asigna colores personalizados para una mejor visualización en los gráficos de toda la plataforma.'
			: 'Switch between tabs to manage different settings. Create tiers to group providers for filtering, organize offices and sites into groups, and assign custom colors for better chart visualization across the platform.',
	},
]
